var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import { getElapsedTime, getUTCTime } from "../utils/getDateAndTimeUTC";
import styled from "styled-components";
import { BoldSpan } from "@atlassiansox/microscopekit";
export var TimeComponent = function (props) { return (React.createElement(BoxWrapper, null,
    React.createElement(Box, null,
        React.createElement(BoldSpan, null, " Start Time"),
        React.createElement("div", null, getUTCTime(props.createdAt))),
    React.createElement(Box, null,
        React.createElement(BoldSpan, null, "End Time"),
        React.createElement(CenterDiv, null, finishedStatuses.includes(props.status)
            ? getUTCTime(props.updatedAt)
            : "-")),
    React.createElement(Box, null,
        React.createElement(BoldSpan, null, "Elapsed Time"),
        React.createElement(CenterDiv, null, getElapsedTime(props.createdAt, props.updatedAt))))); };
var finishedStatuses = [
    "completed",
    "user_abort",
    "success",
    "failed",
    "error"
];
var Box = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-right: 10px;\n  margin-top: 10px;\n"], ["\n  margin-right: 10px;\n  margin-top: 10px;\n"])));
var BoxWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var CenterDiv = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
